export default "<button title=\"{{'BUTTONS.reject' | translate}}\" class=\"btn btn-danger\" (click)=\"reject()\">{{'BUTTONS.reject' | translate}}</button>";